import React from 'react';

const AccountSettings=()=> {
  return <div>
  <h1>
  Account Settings
  </h1>
  </div>;
}

export default AccountSettings;
